export const PAGE_VIEW_ACTIVITY_ID = 4;

export const SITE_ACCESS_ACTIVITY_ID = 9;

export const MEMBERSITE_SOURCE_ID = 7;

export interface UsageLogEntry {
  activityId: number;
  siteId: number;
  sourceId: number;
  userId: string;
  detail: string;
}
